export default {
  // Kế toán viên
  Accountant: 6,
  // Kế toán trưởng
  ChiefAccountant: 3,
  // Uỷ quyền kế toán trưởng
  DelegateChiefAccountant: 5,
  // Thủ trưởng đơn vị
  HeadOfDepartment: 2,
  // Uỷ quyền CTK
  DelegateHeadOfDepartment: 4,
  // Khác
  OtherAccountant: 7,
  //KBNN
  KBNN: 99,
};
